import { Component, Inject, ChangeDetectorRef } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { of } from "rxjs";
import { catchError, finalize } from "rxjs/operators";
import { MarkerService } from "../../services/marker.service";

@Component({
  selector: "app-driver-report-map",
  templateUrl: "./driver-report-map.component.html",
  styleUrls: ["./driver-report-map.component.scss"],
})
export class DriverReportMapComponent {
  public lat = 0;
  public lng = 0;
  public zoom = 3;
  public map: any;
  public placa?: string;
  public address = "";
  public loadingAddress = false;
  public addressVisible = false;
  private latLng?: google.maps.LatLng;
  private autoFetchAddress = false;

  constructor(
    private cdr: ChangeDetectorRef,
    private markerService: MarkerService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.lat = Number(data.lat);
    this.lng = Number(data.lng);
    this.placa = data.placa;

    const enderecoPreenchido =
      typeof data.endereco === "string" && data.endereco.trim().length > 0;
    if (enderecoPreenchido) {
      this.address = data.endereco.trim();
      this.addressVisible = true;
    } else if (data.autoFetchAddress !== false) {
      this.autoFetchAddress = true;
    }
  }

  mapReady(map): void {
    this.map = map;
    this.latLng = new google.maps.LatLng(this.lat, this.lng);
    this.map.setCenter(this.latLng);
    this.map.setZoom(15);

    new google.maps.Marker({
      position: this.latLng,
      map,
      title: this.placa || "",
    });

    if (this.autoFetchAddress) {
      this.showAddress();
    }
  }

  showAddress(): void {
    if (this.addressVisible || this.loadingAddress || !this.latLng) {
      return;
    }

    this.addressVisible = true;
    this.loadingAddress = true;
    this.resolveAddress();
  }

  private resolveAddress(): void {
    if (Number.isNaN(this.lat) || Number.isNaN(this.lng)) {
      this.loadingAddress = false;
      this.address = "Coordenadas inválidas";
      this.cdr.markForCheck();
      return;
    }

    const placa = this.placa?.trim();
    const request$ = placa
      ? this.markerService.getEnderecoByPlaca(placa)
      : this.markerService.getEnderecoByCoordinates(this.lat, this.lng);

    request$
      .pipe(
        catchError(() => of(null)),
        finalize(() => {
          this.loadingAddress = false;
          this.cdr.markForCheck();
        })
      )
      .subscribe((response) => {
        this.address = response?.endereco || "Endereço não localizado";
      });
  }
}
